// extracted by mini-css-extract-plugin
export default {"page_wrap":"CompanyPage_page_wrap__fh0Bw"};